/**
 * Helper
 */
var helper = require('../../helper');

$(function() {

    $.fn.dataTable.moment( 'DD/MM/YYYY' );

    var $datatable = $('#datatable-all-certificates-of-block'),
        blockId = $datatable.data('block'),
        columns = [
            {data: 'type', name: 'type', searchable: false },
            {data: 'date_completed', name: 'documents.date_completed'},
            {data: 'date_expiration', name: 'documents.date_expiration'},
            {data: 'date_contractor_appointment', name: 'documents.date_contractor_appointment'},
            {data: 'propertyName', name: 'propertyName'},
            {data: 'actions', name: 'actions', orderable: false, searchable: false, className : "action" }
        ],
        dataTables_buttons = [],
        $dt;

    $dt = $datatable.DataTable({
        "dom": "<'dt-toolbar'lfB>tr<'row'<'col-sm-5'i><'col-sm-7'p>>",
        "buttons": dataTables_buttons,
        "processing": true,
        "serverSide": true,
        "responsive": true,
        "lengthMenu": [[ 30, 10, 25, 50, 75, 100], [ 30, 10, 25, 50, 75, 100]],
        "ajax": {
            url: helper.getOrigin() + "/api/blocks/" + blockId + "/certificates",
            data: function (d) {
                // d.block_id = blockId;
                d.type_id = $('input[name=type_id]:checked').val();
                d.cert_status = $('input[name=cert_status]:checked').val();
                d.property_type = $('input[name=property_type]:checked').val();
            },
            method: 'POST',
        },
        "autoWidth" : false,
        "order": [[ 0, "asc" ]],
        "columns": columns
    });

    $('#search-form').on('submit', function(e) {

        $dt.draw();
        e.preventDefault();
    });
});
